const AutoRenewalRadioGroup = (function ($) {
    const ARRG = {
        Urls: {
            AutoRenewalRadioGroupChange: '/api/sitecore/MotorPlans/AutoRenewalRadioGroupChange'
        },
        Elements: {
            Id: {
                RadioYes: 'car-auto-renewal-yes',
                RadioNo: 'car-auto-renewal-no',
                UpdateModal: "#car-auto-renewal-updating",
                SuccessModal: "#car-auto-renewal-success",
                ErrorModal: "#car-auto-renewal-error",
                InformationModal: "#renewal-window-information",
                CancelledInformationModal: "#cancelled-window-information",
                RenewalWindow: "#clsRenewalWindow",
                AutoRenewalYes: "#car-auto-renewal-yes",
                AutoRenewalNo: "#car-auto-renewal-no"
            },
            Input: {
                RadioButton: "input[name='car-auto-renewal']"
            }
        },
        BindEvents: function () {
            $(ARRG.Elements.Input.RadioButton).on(
                'change',
                ARRG.Functions.Change
            );
        },
        Functions: {
            Change: function (e) {
                $(ARRG.Elements.Id.UpdateModal).show();
                $.ajax({
                    type: 'POST',
                    url: ARRG.Urls.AutoRenewalRadioGroupChange,
                    data: {isAutoRenew: e.target.id === ARRG.Elements.Id.RadioYes},
                    success: ARRG.Functions.Success,
                    error: ARRG.Functions.Error
                });
            },
            Success: function (data) {
                $(ARRG.Elements.Id.UpdateModal).hide();

                if (data) {
                    $(ARRG.Elements.Id.SuccessModal).show();
                } else {
                    $(ARRG.Elements.Id.ErrorModal).show();
                }
            },
            Error: function () {
                $(ARRG.Elements.Id.UpdateModal).hide();
                $(ARRG.Elements.Id.ErrorModal).show();
            },
            InformationModal: function (data) {
                if (data === "MemberInRenewalWindow") {
                    $(ARRG.Elements.Id.InformationModal).show();
                    $(ARRG.Elements.Id.CancelledInformationModal).hide();
                    $(ARRG.Elements.Id.AutoRenewalYes).prop("disabled", "disabled");
                    $(ARRG.Elements.Id.AutoRenewalNo).prop("disabled", "disabled");
                }
                if (data === "MemberWithCancelledPlan" || data === "MemberWithExpiredPlan") {
                    $(ARRG.Elements.Id.InformationModal).hide();
                    $(ARRG.Elements.Id.CancelledInformationModal).show();
                    $(ARRG.Elements.Id.RenewalWindow).hide();
                }

            },
            Information: function () {
                $(ARRG.Elements.Id.InformationModal).hide();
                $(ARRG.Elements.Id.CancelledInformationModal).hide();
                $.ajax({
                    type: 'GET',
                    url: '/api/sitecore/MotorPlans/GetRenewalInformation',
                    success: ARRG.Functions.InformationModal
                });
            },
        }
    };

    return {
        Init: ARRG.BindEvents,
        Info: ARRG.Functions.Information
    }
})(jQuery);

$('document').ready(function () {
    const pageData = $('#renewal-window-information');
    const inRenewalFeature = 'renewal' === pageData.data('feature');
    AutoRenewalRadioGroup.Init();

    if (inRenewalFeature) {
        AutoRenewalRadioGroup.Info();
    }
});
